
import { IIdsRequest } from "../../../model/request/IIdsRequest";
import { ICaThi } from "../../../model/respone/tct/ICaThi";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eCaThiActionsObj = {
    LOAD_START: undefined,
    LOAD_SUCCESS: {} as ICaThi[],
    LOAD_ERROR: "",

    SHOW_EDIT_MODAL: {} as ICaThi | undefined,
    CLOSE_EDIT_MODAL: undefined,

    SAVE_START: {} as ICaThi,
    SAVE_SUCCESS: {} as ICaThi,
    SAVE_ERROR: "",

    DELETE_START: {} as IIdsRequest,
    DELETE_SUCCESS: undefined,
    DELETE_ERROR: "",

    CHANGE_SELECTED_IDS: {} as number[]
};
export const eCaThiActionIds = generateActionTypeIds(
    eCaThiActionsObj,
    "CA_THI"
);
export type ICaThiActionTypes = IGenericActionType<
    typeof eCaThiActionsObj,
    "CA_THI"
>;
